import React from "react";
import SectionHeader from "../SectionHeader";
import TestimonialCarousel from "../TestimonialCarousel";

const TESTIMONIALS = [
  {
    quote:
      "Byteflow simplified our business operations. The payroll system alone saved us hours every week.",
    name: "Ramesh G.",
    role: "HR Manager, Textile Co.",
  },
  {
    quote:
      "Very intuitive and scalable. We integrated it with our existing tools quickly.",
    name: "Neha M.",
    role: "COO, North Star Retail",
  },
  {
    quote:
      "Great support team and excellent onboarding. Byteflow is the ERP we needed.",
    name: "Akshay T.",
    role: "Founder, Delta Electronics",
  },
];

const TestimonialsSection = () => (
  <section className="section">
    <SectionHeader
      eyebrow="Customer stories"
      title="Teams that grew with Byteflow"
    />
    <TestimonialCarousel items={TESTIMONIALS} />
  </section>
);

export default TestimonialsSection;
